import {
  adminClient,
  emailOTPClient,
  inferAdditionalFields,
  usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { getClientRuntimeValue } from "./runtime-config";

export const AUTH_BASE_URL = getClientRuntimeValue("VITE_BETTER_AUTH_URL");

export const authClient = createAuthClient({
  plugins: [
    adminClient(),
    usernameClient(),
    emailOTPClient(),
    // Mirror the additional user fields declared in et-auth so the session
    // type exposes account_role/account_type (the admin gate + role axis).
    inferAdditionalFields({
      user: {
        account_role: { type: "string", input: false },
        account_type: { type: "string", input: false },
      },
    }),
  ],
  baseURL: AUTH_BASE_URL,
  fetchOptions: {
    credentials: "include", // Required for cookie-based session
  },
});

// Export individual methods for convenience
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  updateUser,
  changePassword,
  emailOtp,
} = authClient;
